// extracted by mini-css-extract-plugin
export default {"background":"Cast_background__D8Jz9","image":"Cast_image__14WsL","svg":"Cast_svg__R5yuC","name":"Cast_name__YGRdB","character":"Cast_character__FgQyR"};